<template>
  <b-button variant="primary" block class="btn-buy" :class="[extraClass, {'disabled': isAlreadyAdded}]" @click="emitClickEvent">
    <div class="labels" :class="{'invisible': loading}" v-if="!isAlreadyAdded">
      <span class="label">{{ title }} {{ price }}</span>
      <span class="sub-label">{{ subtitle }}</span>
    </div>
    <span v-else>{{ $t('pages.checkins_detail.package_banner_btn_added') }}</span>
    <b-spinner label="Loading..." class="spin" v-if="loading"/>
  </b-button>
</template>


<script>


export default {

  props: {
    extraClass: {type: String, required: false},
    title: {type: String},
    subtitle: {type: String},
    discount: {type: String, required: false},
    eventClosed: {type: Boolean},
    price: {type: String},
    priceOriginal: {type: String},
    position: {type: String},
    isAlreadyAdded: {type: Boolean, default: false},
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    emitClickEvent() {
      this.loading = true
      this.$emit('clicked-buy-now')
      // we fake spinner disable, actually not needed as we should move to the checkout
      setTimeout(() => this.loading = false, 2000)
    }
  }
}
</script>
